



























import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { InvoiceDetailsModule } from '@/store/modules/invoiceDetails';
import InvoiceStatus from '@/models/Invoices/InvoiceStatus';
import UpdateInvoiceStatusRequest from '@/models/Invoices/UpdateInvoiceStatusRequest';

@Component({
    name: 'InvoiceStatusSet'
})
export default class extends GiganautVue {
 
  invoiceStatus = InvoiceStatus;

  menu = false;

  get invoice() {
    return InvoiceDetailsModule.currentInvoice;
  }

  get disabled() {
    // Only enable when status is PENDING
    return this.invoice.status !== InvoiceStatus.Pending;
  }

  async setStatusToDeleted() {
    const request = new UpdateInvoiceStatusRequest();
    request.updatedAt = InvoiceDetailsModule.currentInvoice.updatedAt;
    request.status = InvoiceStatus.Deleted;
    await InvoiceDetailsModule.updateInvoiceStatus(request);
  }
}
